import { render, staticRenderFns } from "./SuspensionesHolder.vue?vue&type=template&id=5bae2769&scoped=true"
import script from "./SuspensionesHolder.vue?vue&type=script&lang=js"
export * from "./SuspensionesHolder.vue?vue&type=script&lang=js"
import style0 from "./SuspensionesHolder.vue?vue&type=style&index=0&id=5bae2769&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bae2769",
  null
  
)

export default component.exports